export default {
  date: 'DD/MMM/YYYY',
  dateWithDayName: 'ddd DD/MMM/YYYY',
  dateTime: 'DD/MMM/YYYY HH:mm',
  dateTimeWithSeconds: 'DD/MMM/YYYY HH:mm:ss',
};
